/* eslint-disable */
import request from './helpers'

export function batchTrigger (params) {
    return request ({
        url: '/api/v1/task/triggers/batch',
        method: 'put',
        params
    })
}

export function listBatchTrigger (size, page) {
    return request ({
        url: '/api/v1/task/triggers/list',
        method: 'get',
        params: {
            size,
            page
        }
    })
}

export function deleteBatchTrigger (id) {
    return request ({
        url: '/api/v1/task/triggers/delete/' + id,
        method: 'delete'
    })
}

export function recoveryBatchTrigger (id) {
    return request ({
        url: '/api/v1/task/triggers/recovery/' + id,
        method: 'put'
    })
}

export function listBatchTriggerTasks (triggerId, size, page) {
    return request ({
        url: '/api/v1/task/triggertasks/triggerid',
        method: 'get',
        params: {
            triggerId,
            size,
            page
        }
    })
}

export function listBatchTriggerById (triggerId, size, page) {
    return request ({
        url: '/api/v1/task/triggers/triggerid',
        method: 'get',
        params: {
            triggerId,
            size,
            page
        }
    })
}
